(function () {
  "use strict";

  var el = document.getElementById("sv-intro");
  if (!el) return;

  // Already flagged this session — the inline snippet script already added
  // sv-intro-skip to <html>, so just make sure sessionStorage stays set.
  if (document.documentElement.classList.contains("sv-intro-skip")) {
    return;
  }

  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var duration = parseInt(
    getComputedStyle(el).getPropertyValue("--sv-intro-duration"),
    10
  );
  if (isNaN(duration)) duration = 900;
  if (prefersReducedMotion) duration = 0;

  function finish() {
    try {
      sessionStorage.setItem("sv_intro_shown", "1");
    } catch (e) {
      /* noop */
    }
    el.classList.add("sv-intro-hidden");
    document.body.classList.remove("sv-intro-active");
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 500);
  }

  document.body.classList.add("sv-intro-active");
  setTimeout(finish, duration);
})();
